import { ProfilePage } from '@/modules/identity/ui/pages/ProfilePage';

export const Profile = () => {
  return <ProfilePage />;
};
